const STORAGE_KEY = "selectedAccountSetId";

function safeLocalStorage() {
  try {
    return window.localStorage;
  } catch (err) {
    return null;
  }
}

export function getStoredAccountSetId() {
  const storage = safeLocalStorage();
  if (!storage) return "";
  return storage.getItem(STORAGE_KEY) || "";
}

export function setStoredAccountSetId(accountSetId) {
  const storage = safeLocalStorage();
  if (!storage) return;
  if (accountSetId) {
    storage.setItem(STORAGE_KEY, String(accountSetId));
  } else {
    storage.removeItem(STORAGE_KEY);
  }
}

export function resolveAccountSetId(accountSets, fallbackId = "") {
  if (!Array.isArray(accountSets) || accountSets.length === 0) return "";
  const stored = getStoredAccountSetId();
  const has = (id) => accountSets.some((s) => String(s._id || s.id) === String(id));

  if (stored && has(stored)) return stored;
  if (fallbackId && has(fallbackId)) return fallbackId;

  return accountSets[0]._id || accountSets[0].id || "";
}
